import { useNavigate } from "react-router-dom";
import { useSession } from "../session";

/** Persistent bar shown while an FMC user is operating inside a client tenant. */
export function ImpersonationBanner() {
  const session = useSession();
  const navigate = useNavigate();
  if (!session.impersonating) return null;

  return (
    <div className="shrink-0 bg-primary text-white px-[30px] py-2.5 flex items-center justify-between gap-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className="inline-flex items-center gap-2 px-2 py-1 rounded-xs bg-white/15 text-micro font-semibold uppercase tracking-[0.06em] shrink-0">
          <i className="fa-solid fa-shield-halved text-[10px]" />
          FMC admin
        </span>
        <p className="text-caption text-white/85 truncate">
          You are managing <span className="font-semibold text-white">{session.brand}</span> as{" "}
          {session.adminName}. You have full client-management access; all changes are audit-logged.
        </p>
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <button
          onClick={async () => {
            await session.exitClientView();
            navigate("/admin");
          }}
          className="h-8 px-3 rounded-xs bg-white/15 hover:bg-white/25 text-caption font-semibold transition-colors"
        >
          Back to Admin
        </button>
      </div>
    </div>
  );
}
